let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Va3Y")).then(() => parcelRequire('4UqFQ'));